// IMPORTANT: THIS FILE IS AUTO GENERATED
/* tslint:disable */
export const APP_VERSION = {
    "dirty": false,
    "raw": "603b272",
    "hash": "603b272",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "603b272",
    "semverString": null,
    "version": "1.155.18"
};
/* tslint:enable */
